import React from "react";
import Typography from "@mui/material/Typography";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";

export const StatusBoxDeactivatedProduct = () => {
  return (
    <ContentBox headline={"Produkt nicht mehr unterstützt"}>
      <Typography>
        Dieses Produkt wird von uns nicht mehr angeboten. Bisher erhaltene Dokumente können sie im Bereich “Meine Dokumente” weiterhin abrufen.
      </Typography>
    </ContentBox>
  );
};
